import { ColumnDef } from "@tanstack/react-table";

import { Report } from "./schema";
import { DataTableColumnHeader } from "./data-table-column-header";
// import { Badge } from "@/components/ui/badge/badge";
import { Link } from "react-router-dom";
// import { cn } from "@/lib/utils";

export const columns: ColumnDef<Report, any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => (
      <div>
        <Link
          to={`/admin/all-employees/${row.original.id}`}
          className="hover:underline"
        >
          {row.getValue("name")}
        </Link>
      </div>
    ),
    enableColumnFilter: true,
  },
  {
    accessorKey: "TotalDays",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Total Days in Month" />
    ),
    cell: ({ row }) => <div>{row.original["TotalDays"]}</div>,
  },
  {
    id: "Total Working Days",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Total Working Days" />
    ),
    cell: ({ row }) => <div>{row.original["Total Working Days"]}</div>,
  },
  {
    accessorKey: "Half-day",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Half Days" />
    ),
    cell: ({ row }) => <div>{row.original["Half-day"]}</div>,
  },
  {
    accessorKey: "LateDays",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Late Days" />
    ),
    cell: ({ row }) => <div>{row.original["LateDays"]}</div>,
  },
  {
    accessorKey: "Absent",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Absent" />
    ),
    cell: ({ row }) => <div>{row.original?.Absent}</div>,
  },
  {
    accessorKey: "Paid Leave",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Paid Leaves" />
    ),
    cell: ({ row }) => <div>{row.original["Paid Leave"]}</div>,
  },
  {
    accessorKey: "Holiday",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Holidays" />
    ),
    cell: ({ row }) => <div>{row.original["Holiday"]}</div>,
  },
  {
    accessorKey: "On Leave",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Unpaid Leaves" />
    ),
    cell: ({ row }) => <div>{row.getValue("On Leave")}</div>,
  },
  // {
  //   accessorKey: "Not Counting",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Not Counting" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("Not Counting")}</div>,
  // },

  // {
  //   accessorKey: "Present",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Actual Working Days" />
  //   ),
  //   cell: ({ row }) => <div>{row.original?.Present}</div>,
  // },
  // {
  //   accessorKey: "Holiday",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Holiday" />
  //   ),
  //   cell: ({ row }) => <div>{row.getValue("Holiday")}</div>,
  // },
  // {
  //   id: "Mix",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader
  //       column={column}
  //       title="Total Present Days including Paid Leaves"
  //     />
  //   ),
  //   cell: ({ row }) => (
  //     <div>
  //       {(row.original?.Present as number) +
  //         (row.original?.["Paid Leave"] as number)}
  //     </div>
  //   ),
  // },
  // {
  //   accessorKey: "blocked",
  //   header: ({ column }) => (
  //     <DataTableColumnHeader column={column} title="Status" />
  //   ),
  //   cell: ({ row }) => (
  //     <Badge
  //       className={cn(
  //         row.getValue("blocked") ? "bg-red-400" : "bg-emerald-400"
  //       )}
  //     >
  //       {row.getValue("blocked") ? "Inactive" : "Active"}
  //     </Badge>
  //   ),
  // },

  // {
  //   id: "actions",
  //   cell: ({ row }) => <DataTableRowActions row={row} />,
  // },
];
